import getTranslation from '@/locale/getTranslation'
export default [
  {
    path: '/navigate',
    name: 'navigate',
    component: resolve => require(['@/views/navigate/Index'], resolve),
    meta: {
      title: getTranslation('展区导览'),
      keepAlive: true
    }
  }
]
